import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
}

export const SEO: React.FC<SEOProps> = ({
  title = 'GE Classique – Classic Granado Espada Server',
  description = 'Join the first classic Granado Espada server. Start your journey from version 2.0!',
  keywords = 'Granado Espada, Granado Espada Server, Granado Espada Classique, GE Classique, geclassique, ge classique, Granado Espada private server, MMORPG, classic MMORPG, private MMORPG server, Granado Espada',
  image = 'https://ge-classique.com/logo192.png',
  url = 'https://ge-classique.com/'
}) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="keywords" content={keywords} />
    <meta property="og:type" content="website" />
    <meta property="og:url" content={url} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={image} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:url" content={url} />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image} />
    <link rel="canonical" href={url} />
  </Helmet>
);
